<template>
  <div class="iv-difficult-help">
    <LayoutTitle class="iv-main-width iv-p-t-24 iv-p-b-40" title="帮扶信息" :showBtn="false">
      <DragTable
        class="iv-m-t-24"
        noSearch
        :showSelect="false"
        ref="DragTable" 
        :immediateForce="true" 
        :columns="column"
        :showPage="false"
        :showEdit="false"
        :tableData="tableData">
      </DragTable>
    </LayoutTitle>
    <FooterOperator>
      <div class="iv-text-center">
        <Button type="back" @click="back">返回</Button>
      </div>
    </FooterOperator>
  </div>
</template>

<script>
import column from './column.js'
import { listHelp } from '../interface'
import DragTable from '@/components/drag-table-inline'
import LayoutTitle from '@/components/layout/layout-title'
import FooterOperator from '@/components/footer-operator'

export default {
  data () {
    return {
      tableData: []
    }
  },
  created () {
    this.yearPoorId = this.$decode(this.$route.query.yearPoorId)
    this.column = column.call(this)
    this.getHelpInfo()
  },
  methods: {
    getHelpInfo () {
      listHelp({yearPoorId: this.yearPoorId}).then(({data}) => {
        this.tableData = data
      })
    },
    back () {
      this.$router.push({
        name: 'difficultList',
        query: {
          currentPage: this.$route.query.currentPage || 1
        }
      })
    }
  },
  components: {
    DragTable,
    FooterOperator,
    LayoutTitle
  }
}  
</script>

<style lang="scss" scoped>
  .iv-difficult-help {
    background: #fff;
    height: 100vh;
  }
</style>
